module.exports = __webpack_public_path__ + "media/finishRiddle.83a9a65f.mp3";